<template>
	<div class="floating-menu" :class="{ 'is-floating': isFloating }">
		<transition name="fade" v-if="enableScrollTop">
			<img v-show="isScrollTopShow" class="scroll-top" :class="{ 'is-floating': isFloating }" :src="require('@/assets/scroll_top.svg')" @click="onScrollTopClick" />
		</transition>

		<div class="menu-wrap" v-show="isMenuWrapShow">
			<link-list-item title="マイページ" icon="my_page" @click="onMenuClick('staff')"></link-list-item>
			<link-list-item title="チームトーク" icon="balloon" @click="onMenuClick('team-talk')"></link-list-item>
			<link-list-item title="コインを贈る" icon="coin" @click="onMenuClick('coin-present')"></link-list-item>
			<link-list-item title="記事を書く" icon="news_edit" @click="onMenuClick('news-new')"></link-list-item>
			<link-list-item title="チームを作る" icon="team" @click="onMenuClick('team-new')"></link-list-item>
			<link-list-item title="景品交換" icon="prize" @click="onMenuClick('prize')"></link-list-item>
			<link-list-item title="招待する" icon="invitation" @click="onMenuClick('invitation')"></link-list-item>

			<div class="info-wrap horizontal-center">
				<div class="space"></div>
				<div class="left-wrap">
					<div class="name">{{ auth ? auth.name : '' }}</div>
					<div class="horizontal-center">
						<span class="point-text">所持ポイント</span>
						<span class="point">{{ auth ? auth.point.toLocaleString() : '' }}pt</span>
					</div>
				</div>
			</div>
		</div>

		<avatar :isOutLine="true" :image="auth ? auth.avatar : ''" :width="60" @click="onAvatarClick" :unreadMessageCount="unreadMessageCount"></avatar>
	</div>
</template>

<script>
import LinkListItem from '@/components/LinkListItem'
import Avatar from '@/components/Avatar'
import { mapState } from 'vuex'

export default {
	name: 'FloatingMenu',
	components: {
		LinkListItem,
		Avatar,
	},
	props: {
		enableScrollTop: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isFloating: false,
			isScrollTopShow: false,
			updateTimer: null,
			isMenuWrapShow: false,
		}
	},
	watch: {
		'$route' (to, from) {
			//this.$utils.log('FloatingMenu watch');
			//this.$utils.log('to');
			//this.$utils.log(to.name);
			//this.$utils.log('from');
			//this.$utils.log(from.name);

			if (to.name === 'staff-new' || to.name === 'login') {
				return;
			}

			this.update();
			this.getUnreadMessageCount();
		},
		auth (to, from) {
			if ((!to && from) || (to && !from)) {
				// login状態に変化があった時はインターバル処理を再設定する
				this.setTimerInterval();
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', ()=> {
			//console.log(window.pageYOffset);
			let windowH = document.getElementsByTagName('html')[0].clientHeight;
			this.isScrollTopShow = window.pageYOffset > windowH;
		});

		document.addEventListener('visibilitychange', () => {
			this.setTimerInterval();
		});
		this.setTimerInterval();
	},
	beforeDestroy () {
		if (this.updateTimer) clearInterval(this.updateTimer);
  },
	computed: {
		...mapState([
			'auth',
			'unreadMessageCount',
		]),
	},
	methods: {
		hideMenuWrap: function() {
			let self = this;
			setTimeout(function(){
				self.isMenuWrapShow = false;
			}, 300);
		},
		onAvatarClick: function() {
			// Androidだとキーボードと一緒にフローティングメニューが上がってくるので対策

			if (!this.isFloating) this.isMenuWrapShow = true;
			this.isFloating = !this.isFloating;

			if (!this.isFloating) this.hideMenuWrap();
		},
		onMenuClick: function(name) {
			this.isFloating = false;
			this.hideMenuWrap();

			if (name === 'coin-present') {
				this.$store.commit('disableCoinPresentDataRecovery');
			}

			if (name === 'invitation') {
				this.$store.commit('openInvitationModal');
				return;
			}

			if (this.$utils.isApp()) {
				// アプリの場合はタブを切り替える
				location.href = this.$consts.GOTOTAB_SCHEME + name;
			} else {
				if (name === 'staff') {
					name = 'my-page';
				}
				this.$router.push({ name: name });
			}
		},
		onScrollTopClick: function() {
			this.$SmoothScroll(document.getElementsByTagName('html')[0], 300, null, null, 'y')
		},
		update: async function() {
			let ep = 'staffs/current-info';
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res);
				this.$auth.update(res.data.auth);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		getUnreadMessageCount: async function() {
			let ep = 'TeamTalk/getUnreadMessageCount';
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res);
				this.$store.commit('updateUnreadMessageCount', res.data.count);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		setTimerInterval: function() {
			if (document.visibilityState === "visible" && this.$auth.user) {
				if (this.updateTimer) clearInterval(this.updateTimer);
				let self = this;
				this.updateTimer = setInterval(function() {
					self.update();
					self.getUnreadMessageCount();
				}, 1000);
			} else {
				if (this.updateTimer) clearInterval(this.updateTimer);
			}
		}
	},
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
